import { STEPS, STEP_ICON_MAP, Icons } from "./bookingConstants";
import styles from "./AddBooking.module.css";

const HorizontalStepper = ({ currentStep, onStepClick }) => (
  <div className={styles.stepper}>
    {STEPS.map((s, idx) => {
      const isDone = s.id < currentStep;
      const isActive = s.id === currentStep;
      const statusCls = isDone ? styles.stepDone : isActive ? styles.stepActive : styles.stepUpcoming;
      return (
        <button key={s.id} className={`${styles.stepItem} ${statusCls}`} onClick={() => onStepClick(s.id)}>
          <div className={styles.stepBubble}>
            {isDone ? Icons.check : <span className={styles.stepIcon}>{STEP_ICON_MAP[idx]}</span>}
          </div>
          <div className={styles.stepText}>
            <span className={styles.stepNum}>Step {s.id}</span>
            <span className={styles.stepLabel}>{s.label}</span>
          </div>
          {idx < STEPS.length - 1 && <div className={`${styles.stepConnector} ${isDone ? styles.stepConnectorDone : ""}`} />}
        </button>
      );
    })}
  </div>
);

export default HorizontalStepper;
